export const createCategoryNameMap = () => {
  const categorynamemap = {
    OitaPref: "大分県",
    NakatsuUsa: "中津・宇佐",
    KunisakiPen: "国東半島",
    HitaKusu: "日田・玖珠",
    KokonoeKuju: "九重・久住",
    BeppuYufuin: "別府・湯布院",
    OitaCity: "大分",
    EastCoastOita: "東海岸",
    Bungooono: "豊後大野",
    FukuokaPref: "福岡県",
    NorthernFukuokaPref: "福岡県北",
    MiddleFukuokaPref: "福岡県央",
    AroundIto: "糸島周辺",
    KurumeYame: "久留米・八女",
    NEFukuokaPref: "福岡県北東",
    SagaPref: "佐賀県",
    KaratsuYobuko: "唐津・呼子",
    AroundSaga: "佐賀周辺",
    ImariUreshino: "伊万里・嬉野",
    NagasakiPref: "長崎県",
    Unzen: "雲仙",
    Isahaya: "諫早",
    NagasakiCity: "長崎・西海",
    NorthernNagasakiPref: "長崎県北",
    Sasebo: "佐世保",
    MiyazakiPref: "宮崎県",
    TakachihoNobeoka: "高千穂・延岡",
    MidMtMiyazakiPref: "宮崎県央山",
    MidCoastMiyazakiPref: "宮崎県央海",
    Kirishima: "霧島",
    MiyazakiCity: "宮崎",
    SouthernMiyazakiPref: "宮崎県南",
    KumamotoPref: "熊本県",
    Aso: "阿蘇",
    KumamotoCity: "熊本",
    Amakusa: "天草",
    SouthernKumamoto: "熊本県南",
    KagoshimaPref: "鹿児島県",
    KirishimaSakurajima: "霧島・桜島",
    Osumi: "大隅",
    KagoshimaCity: "鹿児島",
    Ibusuki: "指宿",
    Others: "ツーリング以外のネタ",
    Gear: "使っているもの",
  }
  return categorynamemap
}

export const createCategorySlugMap = () => {
  const categoryslugmap = {
    OitaPref: "/oita-pref",
    NakatsuUsa: "/oita-pref/nakatsu-usa",
    KunisakiPen: "/oita-pref/kunisaki-pen",
    HitaKusu: "/oita-pref/hita-kusu",
    KokonoeKuju: "/oita-pref/kokonoe-kuju",
    BeppuYufuin: "/oita-pref/beppu-yufuin",
    OitaCity: "/oita-pref/oita-city",
    EastCoastOita: "/oita-pref/east-coast-oita",
    Bungooono: "/oita-pref/bungooono",
    FukuokaPref: "/fukuoka-pref",
    NorthernFukuokaPref: "/fukuoka-pref/northern-fukuoka-pref",
    MiddleFukuokaPref: "/fukuoka-pref/middle-fukuoka-pref",
    AroundIto: "/fukuoka-pref/around-ito",
    KurumeYame: "/fukuoka-pref/kurume-yame",
    NEFukuokaPref: "/fukuoka-pref/nefukuoka-pref",
    SagaPref: "/saga-pref",
    KaratsuYobuko: "/saga-pref/karatsu-yobuko",
    AroundSaga: "/saga-pref/around-saga",
    ImariUreshino: "/saga-pref/imari-ureshino",
    NagasakiPref: "/nagasaki-pref",
    Unzen: "/nagasaki-pref/unzen",
    Isahaya: "/nagasaki-pref/isahaya",
    NagasakiCity: "/nagasaki-pref/nagasaki-city",
    NorthernNagasakiPref: "/nagasaki-pref/northern-nagasaki-pref",
    Sasebo: "/nagasaki-pref/sasebo",
    Saikai: "/nagasaki-pref/saikai",
    MiyazakiPref: "/miyazaki-pref",
    TakachihoNobeoka: "/miyazaki-pref/takachiho-nobeoka",
    MidMtMiyazakiPref: "/miyazaki-pref/mid-mt-miyazaki-pref",
    MidCoastMiyazakiPref: "/miyazaki-pref/mid-coast-miyazaki-pref",
    Kirishima: "/miyazaki-pref/kirishima",
    MiyazakiCity: "/miyazaki-pref/miyazaki-city",
    SouthernMiyazakiPref: "/miyazaki-pref/southern-miyazaki-pref",
    KumamotoPref: "/kumamoto-pref",
    Aso: "/kumamoto-pref/aso",
    KumamotoCity: "/kumamoto-pref/kumamoto-city",
    Amakusa: "/kumamoto-pref/amakusa",
    SouthernKumamoto: "/kumamoto-pref/southern-kumamoto",
    KagoshimaPref: "/kagoshima-pref",
    KirishimaSakurajima: "/kagoshima-pref/kirishima-sakurajima",
    Osumi: "/kagoshima-pref/osumi",
    KagoshimaCity: "/kagoshima-pref/kagoshima-city",
    Ibusuki: "/kagoshima-pref/ibusuki",
    Gear: "/others/gear",
  }
  return categoryslugmap
}

export const createCategory2Slug = () => {
  const categoryslugmap = [
    [
      "oita",
      "fukuoka",
      "saga",
      "nagasaki",
      "miyazaki",
      "kumamoto",
      "kagoshima",
    ],
    [
      "nakatsu-usa",
      "kunisaki-pen",
      "hita-kusu",
      "kokonoe-kuju",
      "beppu-yufuin",
      "oita-city",
      "east-coast-oita",
      "bungooono",
      "northern-fukuoka-pref",
      "middle-fukuoka-pref",
      "around-ito",
      "kurume-yame",
      "nefukuoka-pref",
      "karatsu-yobuko",
      "around-saga",
      "imari-ureshino",
      "unzen",
      "isahaya",
      "nagasaki-city",
      "northern-nagasaki-pref",
      "sasebo",
      "saikai",
      "takachiho-nobeoka",
      "mid-mt-miyazaki-pref",
      "mid-coast-miyazaki-pref",
      "kirishima",
      "miyazaki-city",
      "southern-miyazaki-pref",
      "aso",
      "kumamoto-city",
      "amakusa",
      "southern-kumamoto",
      "kirishima-sakurajima",
      "osumi",
      "kagoshima-city",
      "ibusuki",
      "gear",
    ],
  ]

  return categoryslugmap
}

export const createTagsNameMap = () => {
  const tagsnamemap = {
    fivestars: "５つ星",
    fourstars: "４つ星",
    threestars: "３つ星",
    twostars: "２つ星",
    onestar: "１つ星",
    view: "絶景",
    spots: "名所",
    tip: "最端",
    mountain: "山",
    sea: "海",
    specialty: "名物",
    meat: "肉",
    fish: "魚",
    michinoeki: "道の駅",
    omiyage: "お土産",
    tools: "便利ツール",
    review: "レビュー",
    camera: "カメラ",
    touringgear: "ツーリングギア",
  }
  return tagsnamemap
}

export const createLinkStyle = () => {
  const linkstyle = {
    color: "#242424",
    textDecoration: "none",
  }
  return linkstyle
}
